export const env = process.env.REACT_APP_ENV === 'dev' ? 'https://mfb-oo-cat-api.sandbox.royalfloraholland.com/api' : '#{ApiHost}#';